import Actions from 'actions';

const initialState = Object.freeze([]);

function getTier(state = initialState, action) {
  switch (action.type) {
    case Actions.FETCH_MEMBER_TIER_REQUEST:
      return initialState;
    case Actions.FETCH_MEMBER_TIER_SUCCESS:
      return {
        ...initialState,
        data: action.data,
      };
    case Actions.FETCH_MEMBER_TIER_FAIL:
      return {
        ...initialState,
        error: action.error,
      };
    default:
      return state;
  }
}

export default getTier;
